import React, { useState, useEffect } from 'react';
import {Alert, Table, Spinner} from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { getFuncFichaEmpleado } from '../../redux/func_ficha_empleados/actions';
import { getRelationShip } from '../../redux/relationship/actions';
import CustomNavbar from '../../components/CustomNavbar';
import SidebarDashboard from '../../components/SidebarDashboard';
import UserHeadDetail from '../../components/UserHeadDetail';
import UserHeadDetailMenu from '../../components/UserHeadDetailMenu';
import moment from 'moment';
const Dependants = props=> {

  const dispatch = useDispatch();
  const data = useSelector(store => store.funcTabEmployeed.ficha_empleado);
  const loading = useSelector(store => store.funcTabEmployeed.loadingFicha_Empleado);
  const relationsShips = useSelector(store => store.relationship.relationShip);
  //const loadingRelationsShips = useSelector(store => store.relationship.loading);

  useEffect(() => {
    dispatch(getRelationShip(parseInt(props.match.params.type)));
    dispatch(getFuncFichaEmpleado(props.match.params.id, parseInt(props.match.params.type)));
  }, [dispatch, props.match.params.id, props.match.params.type])

  const [show, setShow] = useState(false);
  const onShowSidebar = () => setShow(show ? false : true);

  return(
    <>
      <CustomNavbar  type={'dashboard'} onShowSidebar={onShowSidebar} />
      <SidebarDashboard show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <div className="container mt-3 mb-3">
          {
            loading ? (
              <div className="d-flex justify-content-center">
                <Spinner 
                  animation="border" 
                  role="status" 
                  className="d-flex justify-content-center" />
              </div>
            ) : (
              <>
                <UserHeadDetail data={data} type={props.match.params.type} />
                <div className="my-4">
                  <UserHeadDetailMenu id={props.match.params.id} type={props.match.params.type} />
                    <div className="mt-4 mb-3">
                    <div className="d-flex aling-items-center justify-content-between px-2">
                      <h5 className="font-weight-bold text-uppercase">Familiares</h5>
                      <div>
                        <span className="text-muted mr-3"><i className="material-icons">perm_identity</i> Identidad: {data.identidad}</span>
                        <span className="text-muted"><i className="material-icons">moving</i> Estado civil: {data.Estado_Civil_List ? data.Estado_Civil_List[0].nombre : 'No ingresado aún'}</span>
                      </div>
                    </div>
                    <hr className="mb-3" />
                    <div className="mt-4 mb-3">
                      {
                        data.Dependientes_Economicos_List ? (
                          <Table variant="dark">
                            <thead>
                              <tr>
                                <th scope="col">Identidad</th>
                                <th scope="col">Nombre</th>
                                <th scope="col">Teléfono</th>
                                <th scope="col">Parentesco</th>
                                <th scope="col">Fecha de nacimiento</th>
                                <th scope="col">Dirección</th>
                                <th scope="col">Anotaciones</th>
                              </tr>
                            </thead>
                            <tbody>
                              {
                                data.Dependientes_Economicos_List.map(item => (
                                  <tr key={item.id}>
                                    <td>{item.identidad}</td>
                                    <td>{`${item.nombre} ${item.primer_apellido} ${item.segundo_apellido}`}</td>
                                    <td>{item.telefono}</td>
                                    <td>{relationsShips && relationsShips.find(relShi => relShi.id === item.parentesco) ? relationsShips.find(relShi => relShi.id === item.parentesco).nombre : 'No registrado aún'}</td>
                                    <td>{moment(item.fecha_nacimiento).format('DD/MM/YYYY')}</td>
                                    <td>{item.direccion}</td>
                                    <td>{item.anotaciones}</td>
                                  </tr>
                                ))
                              }
                            </tbody>
                          </Table>
                        ): (
                          <Alert variant="info">
                            <p>No registrados aún</p>
                          </Alert>
                        )
                      }
                    </div>
                  </div>
                </div>
              </>
            )
          }
        </div>
      </div>
    </>
  )
}
export default Dependants